<ion-item lines="none" class="ion-no-padding" [class.auto-pointer-evts]="lockIndicator === true"
  [title]="lockIndicator == true ? lockTitle : ''">
  <ion-label *ngIf="!hideLabel" position="stacked">
    <ion-icon *ngIf="lockIndicator" slot="start" [name]="(disabled) ? 'lock-closed-outline' : 'lock-open-outline'"
      class="no-pointer-evts"></ion-icon>
    {{ label + (required ? '*' : '') }}
    <ion-icon class="help" *ngIf="showHelp" slot="end" name="help-circle-outline" (click)="showHelpMessage()"></ion-icon>
  </ion-label>
  <ion-note slot="helper" *ngIf="helperText != null">{{helperText}}</ion-note>
  <ion-input [type]="type" [id]="id" [placeholder]="placeholder" [(ngModel)]="value" [minlength]="minLength"
    [maxlength]="maxLength" (ionBlur)="checkValidity()" [debounce]="debounce" [disabled]="disabled" 
    [spellcheck]="spellcheck ? 'true' : 'false'"
    [inputFocus]="focus" (keyup)="keyUp($event)" [autocomplete]="autocomplete ? 'on' : 'off'"></ion-input>
</ion-item>
<div class="flex-spaced" *ngIf="subLabel != null || showWordCount" [style.max-width]="'600px'">
  <p class="sub-label">
    {{ subLabel }}
  </p>
  <p *ngIf="showWordCount" [class.danger]="value == null || (maxLength != null && value?.length > maxLength)" class="word-count">
    {{ value?.length || 0 }} / {{ maxLength }}
  </p>
</div>
